import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import classNames from "classnames";
import Chip from "@widget/other/Chip";
import Checkbox from "@widget/forms/inputs/Checkbox";
import Icon from "../../../icons/Icon";
import { hasValue } from "@utils";
/**
 * @export
 * A card in two parts: a picture (or an icon) on top, and the title, description and chips
 * below. All cards in a grid have the same size; long text is cut off. Object search shows
 * its rows with it in card mode.
 *
 * @example Picture
 * ```tsx
 * <ObjectCard
 *     image="https://picsum.photos/400/300"
 *     title="Chiller 2"
 *     description="Plant room · Tower A"
 *     chips={['HVAC']}
 *     badge={{ label: 'Fault', variant: 'danger' }}
 * />
 * ```
 *
 * @example Icon
 * ```tsx
 * <ObjectCard icon="fal file-pdf" title="level-3-plan.pdf" description="Draft floor plan" />
 * ```
 *
 * @category Lists
 */
const ObjectCard = ({ title, description, image, icon, chips, badge, actions, active, selected, onSelect, onClick, layout, className }) => {
    const picture = typeof image === 'string'
        ? (hasValue(image) ? _jsx("img", { className: "uxpcore_objectcard__img", src: image, alt: "", loading: "lazy" }) : null)
        : image;
    return _jsxs("div", { className: classNames("uxpcore_objectcard", {
            "uxpcore_objectcard--active": active,
            "uxpcore_objectcard--selected": selected,
            "uxpcore_objectcard--clickable": !!onClick,
            "uxpcore_objectcard--horizontal": layout === 'horizontal',
        }, className), onClick: onClick, children: [_jsxs("div", { className: "uxpcore_objectcard__top", children: [picture || (hasValue(icon) && _jsx(Icon, { icon: icon, className: "uxpcore_objectcard__icon" })), badge && hasValue(badge.label) && _jsx("div", { className: "uxpcore_objectcard__badge", children: _jsx(Chip, { label: badge.label, variant: badge.variant || 'secondary', size: "small" }) }), onSelect && _jsx("div", { className: "uxpcore_objectcard__check", onClick: e => e.stopPropagation(), children: _jsx(Checkbox, { checked: !!selected, onChange: onSelect, type: "bordered" }) })] }), _jsxs("div", { className: "uxpcore_objectcard__body", children: [_jsxs("div", { className: "uxpcore_objectcard__titleline", children: [_jsx("div", { className: "uxpcore_objectcard__title", children: title }), hasValue(actions) && _jsx("div", { className: "uxpcore_objectcard__actions", onClick: e => e.stopPropagation(), children: actions })] }), hasValue(description) && _jsx("div", { className: "uxpcore_objectcard__description", children: description }), !!(chips === null || chips === void 0 ? void 0 : chips.length) && _jsx("div", { className: "uxpcore_objectcard__chips", children: chips.map((c, i) => typeof c === 'string' ? _jsx(Chip, { label: c, size: "small" }, i) : _jsx(React.Fragment, { children: c }, i)) })] })] });
};
export default ObjectCard;
